<template>
    <modal-live ref="modal">
        <div class="dialog">
            <h2 class="headline--welcome" style="margin-bottom: 20px">
                What best describes you?
            </h2>
            <div>
                <span v-for="(value, label) in preferences.type" :key="label">
                    <input-checkbox
                        :label="label"
                        v-model="preferences.type[label]"
                    ></input-checkbox>
                </span>
            </div>
            <h2 class="headline--welcome" style="margin-bottom: 20px">
                Please select ALL of your current, valid driver`s licences
            </h2>
            <div>
                <span
                    v-for="(value, label) in preferences.experience"
                    :key="label"
                >
                    <input-checkbox
                        :label="label"
                        v-model="preferences.experience[label]"
                    ></input-checkbox>
                </span>
            </div>
            <h2 class="headline--welcome" style="margin-bottom: 20px">
                How many months have you been driving CDL-A within the last 3
                years?
            </h2>
            <div>
                <span
                    v-for="(value, label) in preferences.cdl_experience"
                    :key="label"
                >
                    <input-checkbox
                        :label="label"
                        v-model="preferences.cdl_experience[label]"
                    ></input-checkbox>
                </span>
            </div>
            <div v-if="error.show">
                <div class="alert alert-danger text-center" role="alert">
                    <strong>{{ error.msg }}</strong>
                </div>
            </div>
            <div class="text-center pt-3">
                <Button @click.native="dismiss()" class="text-sm btn-block">
                    Start Using Hammer
                </Button>
            </div>
            <div class="text-center">
                <Bullets :step="step" :steps="steps"></Bullets>
            </div>
        </div>
    </modal-live>
</template>

<script>
export default {
    data() {
        return {
            icons: window.here.icons,
            step: 2,
            steps: 5,
            preferences: {
                type: {
                    'Company Driver': false,
                    'Lease-Purchase Operator': false,
                    'Owner Operator (Leased to Carrier)': false,
                    'Fleet Manager': false,
                    'Independent Owner Operator (Own Authority)': false,
                    'Other (e.g. RVer, pickup, …)': false,
                },
                experience: {
                    'CDL-A': false,
                    'CDL-B': false,
                    'CDL-C': false,
                },
                cdl_experience: {
                    None: false,
                    '1-5 Months': false,
                    '16-12 Months': false,
                    '1-2 Years': false,
                    '2+ Years': false,
                },
            },
            error: {
                show: false,
                msg: '',
            },
        };
    },
    methods: {
        dismiss() {
            const { guid } = this.$route.params;
            axios
                .post('/api/v1/preferences/welcome/completed')
                .then(() => {
                    window.config.welcome_completed = true;
                    this.$refs.modal.dismiss();
                    axios
                        .post('/api/v1/profile/update', {
                            guid,
                            preferences: this.preferences,
                        })
                        .then(() => {
                            this.$router.push({ name: 'home' });
                        });
                })
                .catch(() => {
                    this.error = {
                        show: true,
                        msg: 'Something went wrong. Try again',
                    };
                });
        },
    },
};
</script>
